// extracted by mini-css-extract-plugin
export default {"root":"SafeVerify_root__1Tvwk","btnSubmit":"SafeVerify_btnSubmit__1F_9Y","desc":"SafeVerify_desc__1BPCu","close":"SafeVerify_close__saxQv","modal":"SafeVerify_modal__28Dkp"};